import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class GuidesAnalytics extends AnalyticsBase {
  public readonly namespace = 'Guides';
  public readonly requireViewContext = true;

  public trackMoreVideos() {
    this.track('MoreVideos');
  }

  public trackRoadmap() {
    this.track('Roadmap');
  }

  public trackBlog() {
    this.track('Blog');
  }

  public trackRecruiteeAcademy() {
    this.track('RecruiteeAcademy');
  }

  public trackClassrooms() {
    this.track('Classrooms');
  }

  public trackWhatsNew() {
    this.track('WhatsNew');
  }

  public trackHelpCenter() {
    this.track('HelpCenter');
  }

  public trackIntercom() {
    this.track('Intercom');
  }

  public trackFeedback() {
    this.track('Feedback');
  }
}
